import * as angular from 'angular';

export class FormatCellularStatusFilter {
    public static Factory() {
        var filter = ($filter: angular.IFilterService) => {
            return (status: CASLink.Device.Ui.ViewModel.Modules.CellularDeviceStatusViewModel) => {
                if (typeof status === 'undefined' || status === null || angular.equals(status, {})) {
                    return 'n/a';
                }

                let state = '';
                if (status.isConnected) {
                    // tslint:disable-next-line: prefer-conditional-expression
                    if (status.isActive) {
                        state = 'Active Online';
                    } else {
                        state = 'Inactive Online';
                    }

                } else {
                    if (status.isActive) {
                        state = 'Active Offline';
                    } else {
                        state = 'Inactive Offline';
                    }
                }
                const timestamp = status.timeStamp == null
                    ? ''
                    : ' (' + ($filter('date')(status.timeStamp, 'MM/dd/yyyy @ h:mm:ss a')) + ')';
                return state + timestamp;
            };
        };

        filter.$inject = [
            '$filter'
        ];

        return filter;
    }
}